import { render, staticRenderFns } from "./TargetedSend.vue?vue&type=template&id=154ad716&"
import script from "./TargetedSend.vue?vue&type=script&lang=js&"
export * from "./TargetedSend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports